import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { connect } from "react-redux";
import { addToCart } from "../../actions/cart";

const ListingCard = (props) => {
  const [item, setItem] = useState(props.items);
  useEffect(() => {
    if (!item)
      axios
        .get(
          `https://african-marketplace4.herokuapp.com/api/items/${props.match.params.id}`
        )
        .then((res) => setItem(res.data.item))
        .catch((err) => console.error(err));
  }, [props?.match?.params]);

  if (!item) return <div>Item is Loading</div>;
  return (
    <div>
      <button>
        <Link to={"/all-listings"}>Go Back</Link>
      </button>
      <div className='a-container' key={item.id}>
        <img className='imgid' src={item.photo_url} alt={`${item.name} `} />
        <div className='b-container'>
          <h1>{item.name}</h1>
          <p>{item.description}</p>
          <h2>${item.price}</h2>
          <Link to='/cart'>
            <button onClick={() => props.addToCart(item)} className='mtn-n'>
              Add To Cart
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default connect(null, { addToCart })(ListingCard);
